module.exports = __webpack_public_path__ + "static/services1-242381915bc90a060dd995abc27f7694.jpg";